import { useContext, useMemo } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';

export function useAvailabilityForAnalytics() {
  const {
    hasError,
    data: { action, error, lockType }
  } = useContext(UserVehicleContext).vehicleAvailability;

  return useMemo(
    () => (hasError ? {} : { action, error, lockType }),
    [action, error, hasError, lockType]
  );
}
